module.exports = __webpack_public_path__ + "img/avoid1.bdc71493.png";